export default "__VITE_ASSET__84371acd__"